<template>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!modoEdicao && !showAdmin" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end" >{{ Funcoes.formatInteger(obj.cdestabelecimento) }}</div>
            </div>            

            <div class="form-item-char10">
                <label class="label-caption">SIM Nro</label>
                <div :class="{
                    'field-label-alert': !obj.nrosim,
                    'field-label': obj.nrosim,
                    'field-label-center': true}">{{ obj.nrosim }}</div>
            </div>
            

            <div class="form-item">
                <label class="label-caption">Nome</label>
                <div class="field-label">{{ obj.nmestabelecimento }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">CPF/CNPJ</label>
                <div class="field-label field-label-center">{{ obj.cpfcnpj }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Status</label>
                <div class="field-label field-label-center">{{ obj.xstatus }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item-char40">
                <label class="label-caption">Nome Fantasia</label>
                <div class="field-label">{{ obj.nmfantasia }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Atividade</label>
                <div class="field-label">{{ obj.nmatividade }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ obj.nmsim }}</div>
            </div>
        </div>

  
        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">Área Comercio</label>
                <div class="field-label">{{ obj.nmareacomercio }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Contato</label>
                <div class="field-label">{{ obj.nmcontato }}</div>
            </div>

            <div class="form-item-telefone">
                <label class="label-caption">Telefone</label>
                <div class="field-label">{{ obj.fone }}</div>
            </div>
        
            <div class="form-item-telefone">
                <label class="label-caption">Celular</label>
                <div class="field-label">{{ obj.celular_contato }}</div>
            </div>
        </div>

  
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome RT</label>
                <div class="field-label">{{ obj.rt_nome }}</div>
            </div>

            <div class="form-item-telefone">
                <label class="label-caption">Fone</label>
                <div class="field-label">{{ props.obj.rt_fone }}</div>
            </div>
        </div>

        
        <div class="row-end">
            <button v-if="(props.obj.latitude) || (props.obj.longitude)" type="button" @click="abrirMapa">Ver no Mapa</button>
            <button v-if="globalStore.ckperfilinspetor || globalStore.ckperfilsupervisor" type="button" @click="idEdicao=obj.id; modoEdicao=true;">Editar</button>
            <button v-if="globalStore.ckperfilinspetor" type="button" @click="setEdicaoConfig">Definições</button>
            <button type="button" @click="showAdmin=true">Administradores</button>
            <button type="button" @click="$emit('close')">Fechar</button>
        </div>        
    </div>


    <div v-if="showConfig" class="form-edit-page">
        <h3>DEFINIÇÃO DOS VALORES INICIAIS PARA LAUDOS E PLANILHAS</h3><br>
        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="edPla01Ano">Coleta/Ano</label>
                <input type="text" class="input-right" v-model="edPla01Ano" id="edPla01Ano" v-number maxlength="5" />
            </div>
            
            <div class="form-item">
                <label class="label-caption" for="edPla01Inicial">Coleta/Sequencial</label>
                <input type="text" class="input-right" v-model="edPla01Inicial" id="edPla01Inicial" v-number maxlength="3" />
            </div>

            <div class="form-item">
                <label class="label-caption" for="edPla06Ano">Vistoria/Ano</label>
                <input type="text" class="input-right" v-model="edPla06Ano" id="edPla06Ano" v-number maxlength="5" />
            </div>

            <div class="form-item">
                <label class="label-caption" for="edPla06Inicial">Vistoria/Sequencial</label>
                <input type="text" class="input-right" v-model="edPla06Inicial" id="edPla06Inicial" v-number maxlength="3" />
            </div>

            <div class="form-item">
                <label class="label-caption" for="edPlasAnoInicio">Início Planilhas Ano</label>
                <input type="text" class="input-center" v-model="edPlasAnoInicio" id="edPlasAnoInicio" v-number maxlength="4" />
            </div>

            <div class="form-item-char15"><MesSelect v-model:opcaoSelecionada="mesSelecionado" /></div>
        </div>

        <div class="row-end">
            <button class="btn-confirm" type="button" @click="salvarConfiguracoes">Salvar</button>
            <button class="btn-cancel" type="button" @click="showConfig=false">Cancelar</button>
        </div>    
        
    </div>


    <div v-if="modoEdicao">
        <EstabelecimentoEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="closeFormAndSave" />
    </div>


    <div v-if="showAdmin">
        <EstabelecimentoAdminEditPage :estabelecimentoView="obj" @close="showAdmin = false" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { getCadastroById, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EstabelecimentoAdminEditPage from '../associacoes/EstabelecimentoAdminEditPage.vue';
import EstabelecimentoEditPage from '../formularios/EstabelecimentoEditPage.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import MesSelect from '@/selects/estaticos/MesSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({obj: Object});

const idEdicao=ref(null);
const modoEdicao=ref(false);
const msgAlerta=ref(null);
const showAdmin=ref(false);
const showConfig=ref(false);

const edPla01Ano=ref(null);
const edPla01Inicial=ref(null);
const edPla06Ano=ref(null);
const edPla06Inicial=ref(null);
const edPlasAnoInicio=ref(null);
const mesSelecionado = ref(0);

const closeFormAndSave = () =>{
    emit('close');
    emit('save');
}

function abrirMapa() {
    if ((props.obj.latitude) || (props.obj.longitude)){
        const zoom = 15;
        const url = `https://www.google.com/maps?q=${props.obj.latitude},${props.obj.longitude}&t=k&z=${zoom}`;
        window.open(url, '_blank');
    }
}

async function salvarConfiguracoes(){
    try {
        msgAlerta.value                 = null;
        const response                  = await genericPut('/cad/estabelecimento_config', {
            idestabelecimento: props.obj.id,
            pla01_sequencia_ano: Funcoes.integerFromString(edPla01Ano.value),
            pla01_sequencia_inicial: Funcoes.integerFromString(edPla01Inicial.value),
            pla06_sequencia_ano: Funcoes.integerFromString(edPla06Ano.value),
            pla06_sequencia_inicial: Funcoes.integerFromString(edPla06Inicial.value),
            plas_anomes_inicio: (Funcoes.integerFromString(edPlasAnoInicio.value) * 100) + mesSelecionado.value,
            idlogin: Funcoes.integerFromString(globalStore.idlogin),
            idusuario: Funcoes.integerFromString(globalStore.idusuario)});
        if (response.bolok === 1){
            showConfig.value=false;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;}
}

async function setEdicaoConfig(){
    try{
        msgAlerta.value = null;
        const req = await getCadastroById('estabelecimento_config', props.obj.id);
        if (req[0]!=null){
            edPla01Ano.value = req[0].pla01_sequencia_ano;
            edPla01Inicial.value = req[0].pla01_sequencia_inicial;
            edPla06Ano.value = req[0].pla06_sequencia_ano;
            edPla06Inicial.value = req[0].pla06_sequencia_inicial;

            if (req[0].plas_anomes_inicio > 202500){
                const valorStr = String(req[0].plas_anomes_inicio);
                // edPlasAnoInicio.value = parseInt(req[0].plas_anomes_inicio.substring(0, 4));
                // mesSelecionado.value = parseInt(req[0].plas_anomes_inicio.substring(4, 6));

                edPlasAnoInicio.value = valorStr.slice(0, 4);
                mesSelecionado.value = parseInt(valorStr.slice(4, 6));
                // edPlasAnoInicioMesInicio.value = req[0].plas_anomes_inicio;
            }


    // const valorStr = String(this.valor)
    // this.ano = valorStr.slice(0, 4)
    // this.mes = valorStr.slice(4, 6)

        }
        showConfig.value=true;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;}
}
</script>